import { render, staticRenderFns } from "./ModalCarrocerias.vue?vue&type=template&id=41908cb4&scoped=true&"
import script from "./ModalCarrocerias.vue?vue&type=script&lang=js&"
export * from "./ModalCarrocerias.vue?vue&type=script&lang=js&"
import style0 from "./ModalCarrocerias.vue?vue&type=style&index=0&id=41908cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41908cb4",
  null
  
)

export default component.exports